export default "__VITE_ASSET__CcvoElWf__"